var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.1239C0 16.0613 0.329333 16.8593 0.988 17.5179C1.64667 18.1766 2.44467 18.5059 3.382 18.5059H14.63C15.5547 18.5059 16.3463 18.1766 17.005 17.5179C17.6637 16.8593 17.993 16.0613 17.993 15.1239V10.2599L15.751 12.1409V15.1239C15.751 15.4406 15.6433 15.7066 15.428 15.9219C15.2127 16.1373 14.9467 16.2513 14.63 16.2639H3.382C3.06533 16.2639 2.79933 16.1499 2.584 15.9219C2.36867 15.6939 2.261 15.4279 2.261 15.1239V3.87594C2.261 3.57194 2.36867 3.30594 2.584 3.07794C2.79933 2.84994 3.06533 2.74227 3.382 2.75494H9.006V0.512939H3.382C2.44467 0.512939 1.64667 0.842273 0.988 1.50094C0.329333 2.15961 0 2.95127 0 3.87594L0 15.1239ZM3.382 11.7609C3.382 12.8503 3.59733 13.8953 4.028 14.8959C4.23067 13.7306 4.674 12.6729 5.358 11.7229C6.042 10.7729 6.89067 10.0066 7.904 9.42394C8.91733 8.84127 10.032 8.51194 11.248 8.43594V11.7609L17.993 6.13694L11.248 0.512939V3.87594C10.184 3.87594 9.16433 4.08494 8.189 4.50294C7.21367 4.92094 6.37767 5.48461 5.681 6.19394C4.98433 6.90327 4.42067 7.73927 3.99 8.70194C3.55933 9.66461 3.35667 10.6843 3.382 11.7609Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.af0d6042620a0ea6a06475b932cc82ca.svg";
export { ForwardRef as ReactComponent };